import { useNavigate } from "react-router-dom";
import { ButtonEdit, ButtonDetail, ButtonDelete } from "../common/Button"
import { formatDate,getUniqNewsUrl,getLimitedDetailText } from "../common/BaseUtil"

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faUser } from '@fortawesome/free-regular-svg-icons'; 

export function NewsCardAdmin(props) {
    let navigate = useNavigate();
    function clickSubmit() {
        let objectId = props.object.id.toString()
        let url = "/news?id=" + objectId;
        navigate(url);
    }
   
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{props.object.newsTitle}</h4>
                <p class="card-text">{getLimitedDetailText(props.object.newsContent.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' '))}</p>
                <p class="card-text mt-auto" style={{fontSize:'13px'}}><FontAwesomeIcon icon={faClock}/> {formatDate(props.object.updateAt)}</p>
                <ButtonDetail id={props.object.id} url={"/news_admin?id="}/>
                <ButtonEdit id={props.object.id} url={"/news_modi_admin?id="}/>
                <ButtonDelete id={props.object.id} url={"/delete/news"} objTitle={props.object.newsTitle}/>
            </div>
        </div> 
    );
}